import { NavLink } from 'react-router-dom';
import {useState} from 'react';
import { RootState } from '../../../../../redux/store';
import { useAppSelector } from '../../../../hooks';
import clsx from 'clsx';
import styles from './DropdownMenu.module.css';
import { UserStatus } from '../../../../../models/enums';

const DropdownMenu = () => {
  const [open, setOpen] = useState(false);

  const userStatus: UserStatus = useAppSelector(
    (state: RootState) => state.accountReducer.userStatus
  );

  const handleOpen = () => {
    setOpen(open => !open);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  const memberOnlyDisabled = () => {
    if (
      userStatus === UserStatus.GracePeriodMember ||
      userStatus === UserStatus.ExpiringMember ||
      userStatus === UserStatus.Member
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className={styles.menu}>
      <div className={clsx(styles.menuButton, !open && styles.openMenuButton)} onClick={handleOpen}>Select
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path fill="#fff" d="M352 352c-8.188 0-16.38-3.125-22.62-9.375L192 205.3l-137.4 137.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25C368.4 348.9 360.2 352 352 352z"></path>
        </svg>
      </div>
      <div style={{display : open ? 'block' : 'none'}} className={styles.menu_content}>
        {/* {memberOnlyDisabled() ? <a title='Member Only Feature'>DASHBOARD</a> :
        <NavLink onClick={handleClose} to='/dashboard'>DASHBOARD</NavLink>} */}
        <NavLink onClick={handleClose} to='/account'>ACCOUNT</NavLink>
        <NavLink onClick={handleClose} to='/profile'>PROFILE</NavLink>
        <NavLink onClick={handleClose} to='/newsletters'>NEWSLETTERS</NavLink>
        <NavLink onClick={handleClose} to='/orders'>ORDERS & DONATIONS</NavLink>
        {memberOnlyDisabled() ? <a title='Member Only Feature'>BOOKMARKS</a> :
        <NavLink onClick={handleClose} to='/bookmarks'>BOOKMARKS</NavLink>}
      </div>
    </div>
  );
};

export default DropdownMenu;
